import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import { validateToken } from "./jwt";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchDoctor = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
  return axiosInstance.get(EndPoints.DOCTOR.LIST, {
    params: {
      limit,
      page_no,
      zone_id,
      ...filter,
    },
  });
};

export const fetchInternalDoctor = (payload) => {
  return axiosInstance.get(
    `${EndPoints.DOCTOR.DOCTOR_ASSIGN_ROLE}/${payload?.employee_id}`,
    {
      // params: {
      //     employee_id: payload?.employee_id
      // }
    }
  );
};

export const createDoctor = (payload) => {
  return axiosInstance.post(EndPoints.DOCTOR.CREATE, payload);
};

export const updateDoctor = (payload) => {
  return axiosInstance.put(EndPoints.DOCTOR.UPDATE, payload);
};

export const deleteDoctor = (payload) => {
  const url = EndPoints.DOCTOR.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.DOCTOR.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};

// export const fetchSignature = (
//     payload,
// ) => {
//     const { doctor_id } = payload;
//     return axiosInstance.get(EndPoints.DOCTOR.SIGNATURE_LIST, {
//         params: {
//             doctor_id,
//             zone_id
//         },
//     });
// };

export const fetchSignature = (payload) => {
  if (payload?.token) {
    if (validateToken(payload?.token)) {
      return axiosInstance.get(EndPoints.DOCTOR.SIGNATURE_LIST, {
        params: {
          doctor_id: payload?.doctor_id,
          zone_id: payload?.zone_id,
        },
        headers: {
          Authorization: `Bearer ${payload?.token}`,
        },
      });
    }
    return;
  } else {
    return axiosInstance.get(EndPoints.DOCTOR.SIGNATURE_LIST, {
      params: {
        doctor_id: payload?.doctor_id,
        zone_id: payload?.zone_id,
      },
    });
  }
};
